import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const List = ({ ref, className, ...props }: ComponentProps<"ol">) => (
  <ol ref={ref} className={cn("flex h-5 w-full items-center gap-3 truncate", className)} {...props} />
);
List.displayName = "BreadcrumbList";

export default List;
